<template>
  <div class="page-box">
    <!-- <div class="form">
      <div class="cell">
        <div class="cell-left">
          <span class="label">退货人</span>
          <span class="txt">{{ detailinfo.purchaser }}</span>
        </div>
      </div>
      <div class="cell">
        <div class="cell-left">
          <span class="label">身份证号</span>
          <span class="txt">{{ detailinfo.paperwork }}</span>
        </div>
      </div>
      <div class="cell">
        <div class="cell-left">
          <span class="label">联系电话</span>
          <span class="txt">{{ detailinfo.telephone }}</span>
        </div>
        <a class="cell-right" :href="'tel:' + detailinfo.telephone"></a>
        <img class="cell-right" src="../../../../assets/refund/icon_callPhone.png" alt />
      </div>
      <div class="cell">
        <div class="cell-left">
          <span class="label mr11">是否本人购买</span>
          <span class="txt">{{ detailinfo.isSelf == 1 ? '是' : '否' }}</span>
        </div>
      </div>
    </div> -->
    <div class="divider"></div>
    <div class="form">
      <div class="cell">
        <div class="cell-left">
          <span class="label">购买人</span>
          <span class="txt">{{ detailinfo.submitUser }}</span>
        </div>
      </div>
      <div class="cell">
        <div class="cell-left">
          <span class="label">身份证号</span>
          <span class="txt">{{ detailinfo.submitUserIdCard }}</span>
        </div>
      </div>
      <div class="cell">
        <div class="cell-left">
          <span class="label">联系电话</span>
          <span class="txt">{{ detailinfo.submitUserTel }}</span>
        </div>
        <a class="cell-right" @click="util.callConfirm('拨打该号码？', detailinfo.submitUserTel, 1)" href="javascript:void(0)"></a>
        <!-- <img class="cell-right" src="../../../../assets/refund/icon_callPhone.png" alt /> -->
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.page-box {
  font-family: PingFangSC-Regular;
  padding: 12px;
  background-color: #f8f9fc;
  min-height: 100vh;
  .form {
    padding: 0 16px;
    background-color: white;
    .cell {
      padding: 16px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #fcfcfc;
      .cell-left {
        display: flex;
        align-items: center;
        .label {
          font-size: 16px;
          color: #999999;
          margin-right: 11px;
          min-width: 88px;
          display: inline-block;
          font-weight: 400;
        }
        .mr11 {
          margin-right: 11px;
        }
        .txt {
          font-size: 16px;
          color: #333333;
          display: inline-block;
          vertical-align: middle;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 220px;
          font-weight: 400;
        }
      }
      .cell-right {
        background-size: 100% 100%;
        background: url("../../../../assets/refund/icon_ts_dh@2x.png");
        width: 24px;
        height: 24px;
        background-repeat: no-repeat;
        background-size: 100%;
      }
      &:first-child {
        padding: 21px 0 14px 0;
      }
      &:last-child {
        padding: 15px 0 26px 0;
      }
    }
  }
  .divider {
    background-color: #f8f9fc;
    width: 100%;
    height: 12px;
  }
}
</style>
<script>
    export default {
        data () {
            return {
                detailinfo: {} //
            };
        },
        created () {
            try {
                this.detailinfo = this.$route.query.detailinfo;
            } catch (err) {
                console.log(err);
            }
        },
        methods: {}
    };
</script>
